import React from 'react';

export default function AuthenticationPage() {
  return (
    <div>
      AuthenticationPage
    </div>
  );
};
